import { Level1MenuItem } from "@/features";
import { GiMoneyStack } from "react-icons/gi";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { permissionsCost } from "@/utils";
import { RootState, useAppSelector } from "@/app/store";

const parentPath = "procurement";

export const ProcurementMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const hasCompanies = useAppSelector(
    (state: RootState) => state?.auth?.user?.hasCompanies,
  );

  return (
    <Level1MenuItem
      link={`/${parentPath}`}
      label={gettext("Cost")}
      icon={<GiMoneyStack size={18} className="mx-3" />}
      codes={permissionsCost}
      feature="cost"
      hide={!hasCompanies}
    />
  );
};
